import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';
import Box from '@mui/material/Box';

import '../../AgentStyle.css';
import { textFieldStyle } from '../../../../utils/consts/styles';
import IconButton from '@mui/material/IconButton';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

export const AgentForm = ({ agent, onSave, onCancel, onDelete }) => {
  const [formData, setFormData] = useState({
    id: agent?.id || '',
    name: agent?.name || '',
    company: agent?.company || '',
    email: agent?.email || '',
    phone_number: agent?.phone_number || '',
  });
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const onCloseDialog = () => setIsDialogOpen((prev) => !prev);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    onSave(formData);
  };

  const handleDeleteAgent = () => {
    onDelete();
  };

  return (
    <form onSubmit={handleSave}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px', width: '420px' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <TextField
            color="warning"
            autoFocus
            label="Имя"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            inputProps={textFieldStyle} InputLabelProps={textFieldStyle}
          />
          <TextField
            color="warning"
            label="Компания"
            name="company"
            value={formData.company}
            onChange={handleChange}
            inputProps={textFieldStyle} InputLabelProps={textFieldStyle}
          />
          <TextField
            color="warning"
            label="Email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            inputProps={textFieldStyle} InputLabelProps={textFieldStyle}
          />
          <TextField
            color="warning"
            label="Телефон"
            name="phone_number"
            value={formData.phone_number}
            onChange={handleChange}
            inputProps={textFieldStyle} InputLabelProps={textFieldStyle}
          />
        </Box>
        <Box sx={{ display: 'flex', justifyContent: "space-between" }}>
          <Box sx={{ display: 'flex', gap: '20px' }}>
            <Button type="submit" variant="contained" className="addAgentButton">
              Сохранить
            </Button>
            <Button onClick={onCancel} color="info" variant="outlined" sx={{
              color: '#000',
              borderColor: 'rgba(101,101,101,0.6)'
            }}>
              Отмена
            </Button>
          </Box>
          <IconButton onClick={() => onCloseDialog()}>
            <DeleteOutlineIcon />
          </IconButton>
        </Box>
      </Box>
      <Dialog
        open={isDialogOpen}
        onClose={onCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{ fontFamily: 'Montserrat' }}
      >
        <DialogTitle id="alert-dialog-title" sx={{ fontFamily: 'Montserrat' }}>Удаление агента</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" sx={{ fontFamily: 'Montserrat' }}>
            Вы уверены, что хотите удалить агента?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ fontFamily: 'Montserrat', color: "#FA7A45" }}
            variant="outlined"
            color="warning"
            onClick={() => handleDeleteAgent()}
          >
            Да
          </Button>
          <Button
            sx={{ fontFamily: 'Montserrat', color: "#000" }}
            onClick={() => onCloseDialog()}
          >
            Нет
          </Button>
        </DialogActions>
      </Dialog>
    </form>
  );
};
